export default {
      id: "error-image.withAttrs-usage",
      viewBox: "0 0 441 508",
      url: "/" + "../../Frontend/dist/assets/sprite.svg#error-image.withAttrs",
      toString: function () {
        return this.url;
      }
    }